interface IImgResponsiveSetTypes {
    webp: string;
    jpg: string;
}

export interface IImgResponsiveSet {
    mobile: IImgResponsiveSetTypes;
    tablet: IImgResponsiveSetTypes;
    desktop: IImgResponsiveSetTypes;
}

const imgWidthMobile = 992;
const imgWidthTablet = 1280;
const imgWidthDesktop = 1980;

export function getMobileImage(image: string, imgQuality: number = 80): string {
    return `${image}?fm=jpg&w=${imgWidthMobile}&q=${imgQuality}`;
}

export function getTabletImage(image: string, imgQuality: number = 80): string {
    return `${image}?fm=jpg&w=${imgWidthTablet}&q=${imgQuality}`;
}

export function getDesktopImage(
    image: string,
    imgQuality: number = 80
): string {
    return `${image}?fm=jpg&w=${imgWidthDesktop}&q=${imgQuality}`;
}

export function getImgResponsiveSet(
    image: string,
    imgQuality: number = 80
): IImgResponsiveSet {
    const webpMobile = image
        ? `${image}?fm=webp&w=${imgWidthMobile}&q=${imgQuality}`
        : "";
    const jpgMobile = image
        ? `${image}?fm=jpg&w=${imgWidthMobile}&q=${imgQuality}`
        : "";

    const webpTablet = image
        ? `${image}?fm=webp&w=${imgWidthTablet}&q=${imgQuality}`
        : "";
    const jpgTablet = image
        ? `${image}?fm=jpg&w=${imgWidthTablet}&q=${imgQuality}`
        : "";

    const webpDesktop = image
        ? `${image}?fm=webp&w=${imgWidthDesktop}&q=${imgQuality}`
        : "";
    const jpgDestktop = image
        ? `${image}?fm=jpg&w=${imgWidthDesktop}&q=${imgQuality}`
        : "";

    return {
        mobile: {
            webp: webpMobile,
            jpg: jpgMobile,
        },
        tablet: {
            webp: webpTablet,
            jpg: jpgTablet,
        },
        desktop: {
            webp: webpDesktop,
            jpg: jpgDestktop,
        },
    };
}
